<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>EDI</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="buscar" type="button" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>{{ $t('message.buscar') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <div class="form-field select">
                <div class="select-field">
                  <select v-model="form.linea_id" name="linea" id="linea">
                    <option value>Todas las líneas</option>
                    <option
                      :value="linea.code"
                      v-for="linea in lineas"
                      :key="linea.code"
                    >{{ linea.nombre }}</option>
                  </select>
                  <label for="linea">Filtro por línea</label>
                </div>
              </div>
              <label for="enviados">
                <input
                  @change="buscar"
                  v-model="form.tipo_envio"
                  type="radio"
                  name="tipo_envio"
                  id="enviados"
                  value="S"
                />
                <span>Enviados</span>
              </label>
              <label for="noEnviados">
                <input
                  @change="buscar"
                  v-model="form.tipo_envio"
                  type="radio"
                  name="tipo_envio"
                  id="noEnviados"
                  value="N"
                />
                <span>No enviados</span>
              </label>
              <label for="todos">
                <input
                  @change="buscar"
                  v-model="form.tipo_envio"
                  type="radio"
                  name="tipo_envio"
                  id="todos"
                  value="T"
                />
                <span>Todos</span>
              </label>
              <div class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    @enterkey="buscar"
                    stretch
                    type="date"
                    id="desde"
                    v-model="form.desde"
                  ></date-picker>
                  <label>{{ $t('message.desde') }}</label>
                  <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div class="form-field">
                <div class="datepicker-field datepicker-field--stretch">
                  <date-picker
                    @enterkey="buscar"
                    stretch
                    type="hasta"
                    id="hasta"
                    v-model="form.hasta"
                  ></date-picker>
                  <label>{{ $t('message.hasta') }}</label>
                  <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
              <div class="form-field">
                <input-field
                  @keyup.enter="buscar"
                  name="numeroContenedor"
                  v-model="form.numero_contenedor"
                  id="numeroContenedor"
                  placeholder="#######"
                >{{ $t('message.numeroContenedor') }}</input-field>
              </div>
              <label for="todosEdis">
                <input
                  @change="buscar"
                  type="radio"
                  name="tipo"
                  id="todosEdis"
                  v-model="form.tipo"
                  value="T"
                />
                <span>Todos</span>
              </label>
              <label for="edisIn">
                <input
                  @change="buscar"
                  type="radio"
                  name="tipo"
                  id="edisIn"
                  v-model="form.tipo"
                  value="IN"
                />
                <span>IN</span>
              </label>
              <label for="edisOut">
                <input
                  @change="buscar"
                  type="radio"
                  name="tipo"
                  id="edisOut"
                  v-model="form.tipo"
                  value="OUT"
                />
                <span>OUT</span>
              </label>
              <label for="edisUpd">
                <input
                  @change="buscar"
                  type="radio"
                  name="tipo"
                  id="edisUpd"
                  v-model="form.tipo"
                  value="UPD"
                />
                <span>UPDATE</span>
              </label>
            </div>
            <div class="table-responsive mt-3">
              <k-table
                :buttons="[
                                    {
                                        class : 'btn-info',
                                        icon : 'fa-download',
                                        event : 'descargar'
                                    },
                                    {
                                        class : 'btn-warning',
                                        icon : 'fa-share',
                                        event : 'reenviar'
                                    },
                                    {
                                        class : 'btn-primary',
                                        icon : 'fa-table',
                                        event : 'verHistorial'
                                    }
                                ]"
                @verHistorial="verHistorial"
                @reenviar="reenviar"
                @descargar="descargar"
                noForms
                :params="form"
                :mostrarTodos="false"
                :columns="columns"
                :path="path"
                ref="consultarEdis"
                :deleteButton="false"
                :createButton="false"
                :editButton="false"
              ></k-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="historialEdis" height="auto" width="65%" adaptive resizable reset scrollable>
      <historial-edis :numeroContenedor="numeroContenedorSeleccionado" @cerrar="$modal.hide('historialEdis')"></historial-edis>
    </modal>
  </div>
</template>

<script>
import HistorialEdis from './HistorialEdis.vue';
export default {
  components: {
    HistorialEdis
  },
  props: {
    lineas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: function() {
    return {
      numeroContenedorSeleccionado: '',
      errores: {},
      form: {
        linea_id: "",
        tipo_envio: "T",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        numero_contenedor: "",
        tipo: "T"
      },
      path: url + "/edis",
      columns: [
        {
          display: this.$t("message.numeroContenedor"),
          value: "numero_contenedor"
        },
        {
          display: this.$t("message.tipo"),
          value: "tipo"
        },
        {
          display: this.$t("message.secuencia"),
          value: "secuencial"
        },
        {
          display: "Path",
          value: "path"
        },
        {
          display: this.$t("message.fecha"),
          value: "fecha"
        },
        {
          display: this.$t("message.enviado"),
          value: "enviado"
        }
      ]
    };
  },
  methods: {
    verHistorial: function (row) {
      this.numeroContenedorSeleccionado = row.numero_contenedor;
      this.$modal.show('historialEdis');
    },
    buscar: function() {
      this.$refs.consultarEdis.loadRows();
    },
    descargar: function(row) {
      window.open(url + "/edis/" + row.id, "_blank");
    },
    reenviar: function(row) {
      let that = this;
      swal({
        title: that.$t("message.deseasReenviar"),
        type: "question",
        showCancelButton: true,
        confirmButtonText: that.$t("message.confirmar"),
        cancelButtonText: that.$t("message.cancelar"),
        focusConfirm: true
      }).then(result => {
        if (result.value) {
          axios
            .post(url + "/edis/" + row.id, {
              _method: "PUT"
            })
            .then(function(response) {
              let data = response.data;
              if (data.enviado) {
                swal({
                  text:
                    "Se acaba de mandar el EDI seleccionado al proceso de envío.",
                  focusConfirm: true,
                  title: "Aviso",
                  type: "success"
                });
                that.buscar();
              } else swal("No se puede mandar el EDI seleccionado al proceso de envío. Verifique los parámetros por línea, patio o de envío a través de SMTP o FTP.", "Aviso", "warning");
            })
            .catch(function() {
              swal(
                "Hubo un error. Verifique los parámetros de envío del cliente e intente nuevamente.",
                "Error",
                "error"
              );
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/ConsultaEdis.vue